(function () {
    'use strict';

    angular.module('swif.interventions')

    .service('requestService', requestService);

    function requestService($q, swif, swifInterventionsConstant, swifOpenbaseCompanyService, swifOpenbaseSiteService) {
        'ngInject';

        var service = {};

        service.currentCollection = {};
        service = swifInterventionsConstant.request;
        //Because of promises not fully respected in this service initialisation, we need to duplicate
        //service.COLLECTION_FIELDS into 'intervention_request's fields in the default.json (in order to use it into "alert/notification service" later)
        //
        // **TODO** : refactor initialisation of this service, after swif.service.initialize() promise...
        service.COLLECTION_FIELDS = [
            "actions", "attachment_count", "category_id", "create_date", "create_uid", "process_uid",
            "current_date", "date_deadline", "description", "equipment_id", "id", "swif_id", "is_citizen",
            "mail_message_count", "manager_id", "name", "note", "partner_id", "partner_address", "people_address",
            "people_name", "people_phone", "people_email", "refusal_reason", "site1", "site_details", "site_category",
            "service_id", "shared_with_partner_ids", "state", "type_id", "validation_order_id", "write_uid",
            "claimer_observations", "claimer_priority", "department_estimated_amount", "department_priority",
            "date_production_forecast", "department_observations", "retained_observations", "retained_priority",
            "crossovered_budget", "budget_year", "budget_retained_amount", "budget_notes", "communication_channel_id",
            "contribs_count", "contributions", "geo_point", "last_state_change_date", "note_for_requester",
            "first_response_time", "first_response_time_status", "response_time", "response_time_status",
            "total_process_time", "total_process_time_status", "sms_message_count", "advanced_view"
        ];

        // Filters callback used when exporting to CSV

        swif.settings.initialize().then(settings => {
            settings.getContentType('intervention_request').fields = service.COLLECTION_FIELDS;
        });
        service.resolveData = function (options) {
            return swif.route.check(options).then(function () {
                var deferred = $q.defer();
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Requests';
                data.actionViewsCategory = 'views';
                data.preModal = service.preModal;
                data.callback = service.callback;
                data.preValidate = service.preValidate;
                service.createCollection().then(function (collection) {
                    console.debug("Initialise IR collection");
                    data.requests = collection;
                    service.currentCollection = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };

        service.resolveCommissionData = function (options) {
            return swif.route.check(options).then(function () {
                var deferred = $q.defer();
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Requests';
                data.actionViewsCategory = 'views';
                data.preModal = service.preModal;
                data.callback = service.callback;
                data.preValidate = service.preValidate;
                service.createCommissionCollection().then(function (collection) {
                    data.requests = collection;
                    service.currentCollection = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };

        service.getCountFilter = function () {
            var countFilter = {
                warning: service.getRequestsBaseFilter(),
                info: service.getRequestsBaseFilter()
            };
            swif.data.addFilter(
                countFilter.warning,
                'state', 'in', ['to_confirm']
            );
            swif.data.addFilter(
                countFilter.info,
                'state', 'in', ['wait']
            );
            countFilter.info.fields = swif.settings.getContentType('intervention_request').fields;
            countFilter.warning.fields = swif.settings.getContentType('intervention_request').fields;
            return countFilter;
        };

        service.getRequestsBaseFilter = function () {
            var filter = {};
            var user = swif.user.getAuthenticatedUserData();
            if (!_.contains(user.access_rights, 'openstc_requests_read_all')) {
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                if (user.partner_id) {
                    swif.data.addExtraFilter(filter, 'view', '|');
                }
                if (user.partner_ids) {
                    swif.data.addExtraFilter(filter, 'view', '|');
                }
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', 'create_uid', '=', user.id);
                swif.data.addExtraFilter(filter, 'view', 'partner_id.address', 'in', user.contact_id);
                swif.data.addExtraFilter(filter, 'view', 'intervention_ids.tasks.user_id.id', '=', user.id);
                swif.data.addExtraFilter(filter, 'view', 'intervention_ids.tasks.team_id.id', 'in', user.team_ids);
                swif.data.addExtraFilter(filter, 'view', 'service_id', 'in', user.service_ids);
                swif.data.addExtraFilter(filter, 'view', 'validation_order_id.block_id.block_ids.choice_ids.user_id', '=', user.id);
                swif.data.addExtraFilter(filter, 'view', 'contributions.create_uid', 'in', [user.id]);
                if (user.partner_id){
                    swif.data.addExtraFilter(filter, 'view', 'shared_with_partner_ids', 'in', [user.partner_id[0]]);
                }
                if (user.partner_ids){
                    swif.data.addExtraFilter(filter, 'view', 'shared_with_partner_ids', 'in', user.partner_ids);
                }
                swif.data.addExtraFilter(filter, 'view', 'shared_with_user_ids', 'in', [user.id]);
                swif.data.addExtraFilter(filter, 'view', 'state', '!=', 'merged');
            }
            return filter;
        };

        service.getRequestsFilter = function () {
            var ret = $q.defer();

            swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                var filter = service.getRequestsBaseFilter();

                var default_states = company.state_default_filters;
                if (default_states) {
                    swif.data.addFilter(filter, 'state', 'in', default_states);
                }

                ret.resolve(filter);
            });

            return ret.promise;
        };

        service.createCollection = function () {
            return service.getRequestsFilter().then(function (filter) {

                filter.fields = swif.settings.getContentType('intervention_request').fields;
                if (swif.module.modules.opengst_carto && filter.fields.indexOf('geo_point') < 0) {
                    filter.fields.push('geo_point');
                }
                if (swif.module.modules.ozwillo) {
                    filter.fields.push('oz_body', 'oz_type', 'oz_datetime', 'oz_response_ids');
                }
                swif.data.addExtraFilter(filter, 'is_parcauto', 'is_parcauto', '=', false);
                swif.data.addExtraFilter(filter, 'view', 'state', '!=', 'merged');
                swif.data.sortOn(filter, 'id', 'DESC');
                return swif.collections.createOrUpdate(
                    'requests',
                    'intervention_request',
                    filter,
                    {location: true}
                );
            });
        };

        service.createCollectionContribs = function (request) {
            var filter = {};
            swif.data.addExtraFilter(filter, 'inRequest', 'ask_id', '=', request.id);
            swif.data.setLimit(filter, 10);
            swif.data.sortOn(filter, 'id', 'ASC');
            return swif.collections.createOrUpdate(
                'request-contribs',
                'ask_contrib',
                filter
            );
        };

        service.createCommissionCollection = function () {
            return service.getRequestsFilter().then(function (filter) {
                filter.fields = swif.settings.getContentType('intervention_request').fields;
                if (swif.module.modules.opengst_carto && filter.fields.indexOf('geo_point') < 0) {
                    filter.fields.push('geo_point');
                }
                if (swif.module.modules.ozwillo) {
                    filter.fields.push('oz_body', 'oz_type', 'oz_datetime', 'oz_response_ids');
                }
                swif.data.addExtraFilter(filter, 'view', 'is_parcauto', '=', false);
                // we want to show a request in the commission view as soon as there is one complete field
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', '|');
                swif.data.addExtraFilter(filter, 'view', 'claimer_priority', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'claimer_observations', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'department_priority', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'department_estimated_amount', '!=', 0);
                swif.data.addExtraFilter(filter, 'view', 'date_production_forecast', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'department_observations', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'retained_priority', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'retained_observations', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'budget_retained_amount', '!=', 0);
                swif.data.addExtraFilter(filter, 'view', 'crossovered_budget', '!=', false);
                swif.data.addExtraFilter(filter, 'view', 'budget_notes', '!=', false);
                swif.data.sortOn(filter, 'id', 'DESC');
                return swif.collections.createOrUpdate(
                    'requests',
                    'intervention_request',
                    filter,
                    {location: true}
                );
            });
        };

        service.refreshAllCollections = function () {
            swif.collections.refreshCollections([
                'requests'
            ]);
        };

        service.callbackMessage = function (error, data) {
            swif.collections.defaultCallbackMessage(error, data);
            if (!error) {
                switch (data.action.id) {
                    case 'validate':
                        swif.message.addInfo('Request has been validated successfully');
                        break;
                    case 'refuse':
                        swif.message.addInfo('Request has been refused successfully');
                        break;
                    case 'to_confirm':
                        swif.message.addInfo('Request has been make as to confirmed successfully');
                        break;
                    case 'transfer':
                        swif.message.addInfo('Request has been transfered successfully');
                        break;
                }
            }
        };

        service.callbackCollection = function (collection, data) {
            collection.fasterCallback(data);
            if (_.contains([
                    'validate',
                    'to_confirm',
                    'refuse',
                    'complete',
                    'transfer',
                    'validate_survey',
                    'refuse_survey'
                ], data.action.id)) {
                collection.updateItem(data.model);
            }
            if (_.contains(['add', 'complete'], data.action.id)) {
                data.model.state = 'wait';
            }
        };

        service.preModal = function (data) {
            swif.collections.getCollection('requests').preModal(data);
            if (data.action.id === 'validate') {
                var request = data.model;
                var copy = angular.copy;
                data.model = copy(data.model);
                delete data.model.id;
                delete data.model.state;
                data.model.request = request;
                data.model._type = 'intervention';
                data.model.is_long_term = false;
                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                    data.model.create_task = company.add_intervention_window_create_task;
                });
                //task is created by the controller from create_task watcher
            } else if (data.action.id === 'refuse') {
                if (swif.settings.app.modules.openstc_patrimoine && data.model.site1) {
                    swifOpenbaseSiteService.getSiteAddressById(data.model.site1[0]).then(site => {
                        swifOpenbaseSiteService.getSiteAddressFields().map(field => {
                            data.model[field] = site[field];
                        });
                    });
                }
            }
        };

        service.callback = function (error, data) {
            service.callbackMessage(error, data);
            var collection = swif.collections.getCollection('requests');
            if (!error) {
                service.callbackCollection(collection, data);
            }
        };

        service.preValidate = function (data) {
            var validated = swif.collections.preValidate(data),
                user = swif.user.getAuthenticatedUserData();

            if (data.action.id === 'validate') {
                var copy = angular.copy;
                var request = copy(data.model.request);
                var inter = copy(data.model);
                var tasks = copy(data.model._tasks);
                delete inter.request; //remove to not have circular structure
                delete inter.tasks;
                var sanitized = [];
                sanitized.push(swif.data.sanitizeData('intervention', inter));
                angular.forEach(tasks, function(task) {
                    // send a flag to task model to know whether the feature is activated or not
                    var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
                    if (siteOnTaskFeature) {
                        task.has_site_on_task_feature = siteOnTaskFeature;
                    }
                    var ctask = angular.copy(task);

                    // Duplicate from intervention service... because no better solution atm wirh actual architecture
                    if (Array.isArray(ctask.user_id) && Number.isInteger(ctask.user_id[1])) {
                        // Duplicate task with main attribute when multiple user_ids
                        var user_ids = ctask.user_id;
                        for (const id of user_ids) {
                            var dupTask = angular.copy(ctask);
                            dupTask.user_id =  [id, ''];
                            // Remove useless attributes for secondary tasks
                            delete dupTask.consumable_request_ids
                            delete dupTask.consumable_asks
                            delete dupTask.consumables
                            delete dupTask.vehicule
                            delete dupTask.equipment_ids
                            delete dupTask.purchase_order
                            delete dupTask.oil_price
                            delete dupTask.oil_qtity
                            delete dupTask.km
                            sanitized.push(swif.data.sanitizeData('task', dupTask));
                        }
                    } else {
                        sanitized.push(swif.data.sanitizeData('task', ctask));
                    }
                });
                return $q.all(sanitized).then(function (sdata) {
                    inter = sdata.splice(0, 1)[0]; // Take and remove first element. Other are tasks
                    inter.tasks = [];
                    angular.forEach(sdata, function(stask) {
                        inter.tasks.push([0, 0, stask]);
                    });
                    request.intervention_ids = [[0, 0, inter]];
                    request.process_uid = [user.id, user.complete_name];
                    request.state = 'valid';
                    swif.data.replaceObj(data.model, request);
                    return true;
                });
            } else if (data.action.id === 'refuse') {
                data.model.state = 'refused';
                data.model.process_uid = [user.id, user.complete_name];
            } else if (data.action.id === 'to_confirm') {
                // first, prepare the object representing the whole data of the validation object
                // (it contains all the deep data inside it)
                if (data.model.survey) {
                    // i sanitize the object to match the expected input of prepareObjectForSave()
                    if (!data.model.survey.items && data.model.survey.to_confirm) {
                        data.model.survey.items = data.model.survey.to_confirm;
                    }
                    var val = swif.validation.prepareObjectForSave(data.model.survey);
                    // then, compute the related 'resource' (res_id, res_model)
                    val.res_id = data.model.id;
                    var contentType = swif.settings.getContentType('intervention_request').model;
                    val.res_model = contentType || 'openstc.ask';
                    val.note_for_requester = data.model.survey.note_for_requester;
                    // perform the create()
                    var validDefer = swif.data.create('validation-order', val, { 'should_notify_requester': data.model.survey.should_notify_requester})
                        .then(function () {
                            service.callback(undefined, data);
                        });

                    // at the same time, if user choose to keep it as template,
                    // create the template too
                    var tmplDefer = true;
                    if (data.model.saveAsTemplate) {
                        tmplDefer = swif.data.create('validation-block-template', val)
                            .then(function () {
                                service.callback(undefined, data);
                            });
                    }
                    // finally, compute and return the defer
                    validated = $q.all([validDefer, tmplDefer]);
                }
            } else if (data.action.id === 'validate_survey') {
                validated = swif.data.callKw(
                    'intervention_request',
                    'confirm_survey',
                    [data.model.id],
                    {note: data.model.note || ''}
                ).then(function () {
                    service.callback(undefined, data);
                    return true;
                });
            } else if (data.action.id === 'refuse_survey') {
                validated = swif.data.callKw(
                    'intervention_request',
                    'refuse_survey',
                    [data.model.id],
                    {note: data.model.note || ''}
                ).then(function () {
                    service.callback(undefined, data);
                    return true;
                });
            } else if (data.action.id === 'transfer') {
                var res = {
                    service_id: data.model.service_id ? data.model.service_id[0]: false,
                    note: data.model.note || '',
                    user_ids: data.model.user_ids || [],
                    address_ids: data.model.address_ids || [],
                    add_claimer: data.model.add_claimer || false,
                    add_followers: data.model.add_followers || false,
                    save_as_template: data.model.save_as_template || ''
                };

                return swif.data.callKw(
                    'intervention_request',
                    'transfer_request',
                    [data.model.id],
                    res
                );
            }
            return validated;
        };

        service.getTooltip = function (request) {
            if (request.tooltip) {
                return request.tooltip;
            }
            var modifyBy;
            var tooltip = '';
            if (request.process_uid) {
                modifyBy = request.process_uid[1];
            }
            if (request.state === 'refused') {
                tooltip += request.refusal_reason;
                if (modifyBy) {
                    tooltip += ' (' + modifyBy + ')';
                }
            } else if (request.state === 'to_confirm' && request.note) {
                tooltip += request.note ;
            }
            if (request.state === 'valid' && modifyBy) {
                tooltip += 'Par ' + modifyBy;
                //Par 'xxx' non planifiée
                //Par 'xxx' prévu le yyy
            }
            if (!_.isEmpty(tooltip)) {
                return tooltip;
            }
            /**
             TODO: we must refactor this code from the server
             using the new system of popover on top of the state
             a state should be able to provide information around
             def _tooltip(self, cr, uid, ids, myFields, arg, context):
             res = {}

             ask_obj = self.pool.get('openstc.ask')
             project_obj = self.pool.get('project.project')
             task_obj = self.pool.get('project.task')
             user_obj = self.pool.get('res.users')
             modifyBy = ''
             loc = locale.getlocale()
             ucontext = user_obj.context_get(cr, uid)
             if ucontext and ucontext['lang']:
             locale.setlocale(locale.LC_ALL, (ucontext['lang'], 'UTF-8'))

             for id in ids:
             res[id] = ''

             ask = ask_obj.browse(cr, uid, id, context)
             if ask:
             if ask.write_uid:
             modifyBy = user_obj.browse(cr, uid, ask.write_uid.id, context).name
             if ask.state == 'valid' or ask.state == 'finished':
             for intervention_id in ask.intervention_ids:
             first_date = None
             last_date = None
             intervention = project_obj.browse(cr, uid, intervention_id.id, context)
             if intervention:
             for task_id in intervention.tasks:
             task = task_obj.browse(cr, uid, task_id.id, context)
             if task:
             if first_date is None:
             first_date = task.date_start
             elif task.date_start and first_date > task.date_start:
             first_date = task.date_start

             if last_date is None:
             last_date = task.date_end
             elif task.date_end and last_date < task.date_end:
             last_date = task.date_end
             user = user_obj.browse(cr, uid, intervention.create_uid.id, context)
             res[id] = _(" By ") + user.name

             if last_date:
             last_date = fields.datetime.context_timestamp(cr, uid,
             datetime.strptime(last_date, '%Y-%m-%d  %H:%M:%S')
             , context)

             if first_date:
             first_date = fields.datetime.context_timestamp(cr, uid,
             datetime.strptime(first_date, '%Y-%m-%d  %H:%M:%S')
             , context)

             if ask.state == 'finished':
             if intervention.state == 'finished' and last_date:
             res[id] += _(' Ended date ') + last_date.strftime(_("%A, %d. %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             else:
             if intervention.cancel_reason:
             res[id] += intervention.cancel_reason
             else:
             res[id] = _(' intervention cancelled ')

             elif first_date:
             if intervention.progress_rate == 0:
             res[id] += _(' Scheduled start date ') + first_date.strftime(_("%A, %d. %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             elif intervention.progress_rate == 100 :
             res[id] += _(' Ended date ') + last_date.strftime(_("%A, %d. %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             elif last_date:
             res[id] += _(' Scheduled end date ') + last_date.strftime(_("%A, %d. %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             else:
             res[id] += _(" To plan ")
             else:
             res[id] += _(" Not plan ")

             elif ask.state == 'refused':
             if ask.refusal_reason:
             res[id] = ask.refusal_reason + '\n(' + modifyBy + ')'
             else:
             res[id] = _(' request refused ')

             elif ask.state == 'to_confirm':
             if ask.note:
             res[id] = ask.note + '\n(' + modifyBy + ')'
             else:
             res[id] = _(' request confirmed ')

             locale.setlocale(locale.LC_ALL, loc)
             return res
             */
        };

        service.getFilters = function (request) {
            var filters = {
                partner_address: {fields: ['name', 'complete_name', 'partner_id', 'is_active']},
                partner: {},
                department: {},
                technical_department: {},
                intervention_category: {},
                task_category: {},
                ask_category: {fields: ['name', 'description', 'service_id']}
            };
            swif.data.addFilter(
                filters.partner, 'customer', '=', true
            );
            swif.data.addFilter(
                filters.partner_address,
                'partner_id.customer', '=', true
            );
            swif.data.addFilter(
                filters.department,
                'is_assignable_to_ask', '=', true
            );
            //if organisation is set, filter contact on it.
            if (request.partner_id) {
                swif.data.addFilter(
                    filters.partner_address,
                    'partner_id.id', '=', request.partner_id[0]
                );
            }
            //validate a request:
            swif.data.addFilter(
                filters.technical_department,
//                    'technical', '=', true
                'is_assignable_to_project', '=', true
            );
            if (request.service_id) {
                filters.task_category = {};
                swif.data.addFilter(filters.task_category, '|');
                swif.data.addFilter(
                    filters.task_category,
                    'service_ids.id', '=', request.service_id[0]
                );
                swif.data.addFilter(
                    filters.task_category,
                    'service_ids', '=', false
                );
            }
            var user = swif.user.getAuthenticatedUserData();
            if (
                !_.contains(user.access_rights, 'DIRE') &&
                !_.contains(user.access_rights, 'MANA') &&
                !_.contains(user.access_rights, 'RCPT')
            ) {
                swif.data.addFilter(filters.partner, 'address.user_id', '=', user.id);
                swif.data.addFilter(filters.partner_address, 'user_id', '=', user.id);
            }
            swif.user.getPartner(['technical_service_ids']).then(function (partner) {
                if (partner && !_.isEmpty(partner.technical_service_ids)) {
                    swif.data.addFilter(
                        filters.department,
                        'id', 'in', partner.technical_service_ids
                    );
                }
            });
            if (request.equipment_id) {
                swif.data.get('equipment', request.equipment_id[0], {fields: ['maintenance_service_ids']})
                    .then(function (eq) {
                        if (_.size(eq.maintenance_service_ids) > 0) {
                            swif.data.addFilter(
                                filters.department,
                                'id', 'in',
                                eq.maintenance_service_ids
                            );
                        }
                    });
            }
            return filters;
        };

        service.showValidation = function (model) {
            var action = swif.action.getActionById(
                'intervention_request',
                'validation',
                'show_validation',
                model
            );
            if (action) {
                swif.action.dispatch('intervention_request', action, model);
            }
        };

        return service;
    }

})();
